// extracted by mini-css-extract-plugin
export var animationContainer = "_e9-0";
export var asteriskIcon = "_e9-8";
export var conversationLeftSection = "_e9-4";
export var conversationListItem = "_e9-3";
export var conversationMiddleSection = "_e9-5";
export var conversationRightSection = "_e9-6";
export var detailsContent = "_e9-1";
export var listContainer = "_e9-7";
export var modalContent = "_e9-2";